import React from "react"
import common_images from "../../common-images";
import ContentIcon from "./content-icon";

class ContentUnitIcon extends React.Component {
    render() {
        const { contentUnit, alt, className, fill } = this.props;
        switch (contentUnit.type) {
            case 'ContentUnits::PersonalForm':
            case 'ContentUnits::MedicalExamDownload':
            case 'ContentUnits::MedicalExamUpload':
            case 'ContentUnits::Video':
                return (<ContentIcon type={contentUnit.type} alt={alt} className={className} fill={fill}/>);

            default:
                switch (contentUnit.category) {
                    case "important_document":
                        return (<ContentIcon type='ImportantDocument' alt={alt} className={className} fill={fill}/>);

                    case "life_at_innogy":
                        return (<ContentIcon type='LifeAtInnogy' alt={alt} className={className} fill={fill}/>);
                }

                return (<ContentIcon type={contentUnit.type} alt={alt} className={className} fill={fill}/>);
        }
    };
}

export default ContentUnitIcon;
